import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import BRAND from "../theme/talktokam";

const PressKit = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ background: "#050816", minHeight: "100vh" }}>
      <Box
        sx={{
          position: "relative",
          textAlign: "center",
          py: { xs: 10, md: 14 },
          background: `radial-gradient(ellipse 800px 600px at 20% 10%, ${BRAND.cyan}33 0%, transparent 60%), radial-gradient(ellipse 700px 500px at 85% 90%, ${BRAND.purple}33 0%, transparent 60%), radial-gradient(ellipse 600px 400px at 50% 50%, ${BRAND.primary}1a 0%, transparent 60%), linear-gradient(180deg, #050816 0%, #0a0e27 50%, #050816 100%)`,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `linear-gradient(rgba(56,189,248,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(56,189,248,0.04) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
            maskImage:
              "radial-gradient(ellipse at center, black 30%, transparent 70%)",
            WebkitMaskImage:
              "radial-gradient(ellipse at center, black 30%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <motion.div
          animate={{ y: [0, -40, 0], scale: [1, 1.1, 1] }}
          transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
          style={{
            position: "absolute",
            top: "5%",
            left: "-5%",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${BRAND.cyan}40 0%, transparent 70%)`,
            filter: "blur(60px)",
            pointerEvents: "none",
          }}
        />
        <motion.div
          animate={{ y: [0, 40, 0], scale: [1, 1.15, 1] }}
          transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
          style={{
            position: "absolute",
            bottom: "-10%",
            right: "-10%",
            width: 600,
            height: 600,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${BRAND.purple}40 0%, transparent 70%)`,
            filter: "blur(80px)",
            pointerEvents: "none",
          }}
        />
        <motion.div
          animate={{ y: [0, -25, 0], x: [0, 20, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
          style={{
            position: "absolute",
            top: "50%",
            right: "30%",
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: `radial-gradient(circle, ${BRAND.primary}26 0%, transparent 70%)`,
            filter: "blur(40px)",
            pointerEvents: "none",
          }}
        />
        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "2rem", md: "3rem" },
                background: "linear-gradient(135deg, #38bdf8, #a855f7)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mb: 2,
              }}
            >
              Talktokam Press Resources
            </Typography>
            <Typography
              sx={{
                fontSize: "1.1rem",
                color: "#94a3b8",
                maxWidth: 500,
                mx: "auto",
              }}
            >
              Logos, screenshots, brand guidelines, and company information for
              media use.
            </Typography>
          </motion.div>
        </Container>
      </Box>

      <Box
        sx={{ background: "linear-gradient(180deg, #0a0e27 0%, #050816 100%)" }}
      >
        <Container sx={{ py: { xs: 6, md: 10 } }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.3rem",
                    background: "linear-gradient(135deg, #38bdf8, #a855f7)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    mb: 2,
                  }}
                >
                  Brand Assets
                </Typography>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "rgba(99,102,241,0.1)",
                    border: "1px solid rgba(99,102,241,0.3)",
                    mb: 2,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: "2rem",
                      background: "linear-gradient(135deg, #38bdf8, #a855f7)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Talktokam
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.85rem", color: "#94a3b8", mt: 1 }}
                  >
                    Full logo (PNG/SVG)
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "#0a0e27",
                    border: "1px solid rgba(255,255,255,0.08)",
                    mb: 2,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 800, fontSize: "2rem", color: "#fff" }}
                  >
                    Talktokam
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.85rem", color: "#94a3b8", mt: 1 }}
                  >
                    White logo for dark backgrounds
                  </Typography>
                </Box>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => navigate("/contact")}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "rgba(99,102,241,0.5)",
                    color: "#6366f1",
                    "&:hover": {
                      borderColor: "#6366f1",
                      bgcolor: "rgba(99,102,241,0.1)",
                    },
                    mb: 2,
                  }}
                >
                  Download Logo Pack (ZIP)
                </Button>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.3rem",
                    background: "linear-gradient(135deg, #38bdf8, #a855f7)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    mb: 2,
                  }}
                >
                  Brand Colors
                </Typography>
                <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
                  {[
                    { hex: "#6366f1", name: "Primary Indigo" },
                    { hex: "#8b5cf6", name: "Secondary Violet" },
                    { hex: "#38bdf8", name: "Cyan" },
                    { hex: "#a855f7", name: "Purple" },
                    { hex: "#0a0e27", name: "Navy" },
                  ].map((c, i) => (
                    <Box key={i} sx={{ textAlign: "center" }}>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          borderRadius: 2,
                          bgcolor: c.hex,
                          mb: 0.5,
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      />
                      <Typography
                        sx={{ fontSize: "0.65rem", color: "#94a3b8" }}
                      >
                        {c.hex}
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.65rem", color: "#64748b" }}
                      >
                        {c.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.3rem",
                    background: "linear-gradient(135deg, #38bdf8, #a855f7)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    mb: 2,
                  }}
                >
                  Typography
                </Typography>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "rgba(255,255,255,0.05)",
                    backdropFilter: "blur(16px)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    transition: "all 0.3s",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      borderColor: "rgba(56,189,248,0.3)",
                      boxShadow: "0 12px 40px rgba(56,189,248,0.1)",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 800,
                      fontSize: "1.5rem",
                      color: "#fff",
                    }}
                  >
                    Poppins Bold
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      color: "#cbd5e1",
                    }}
                  >
                    Poppins Semibold
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "1rem",
                      color: "#94a3b8",
                    }}
                  >
                    Inter Regular — Body text
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          </Grid>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                mt: 6,
                p: 4,
                borderRadius: 4,
                bgcolor: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(16px)",
                border: "1px solid rgba(255,255,255,0.08)",
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  borderColor: "rgba(56,189,248,0.3)",
                  boxShadow: "0 12px 40px rgba(56,189,248,0.1)",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  color: "#fff",
                  mb: 1,
                }}
              >
                Company Description
              </Typography>
              <Typography
                sx={{ fontSize: "0.9rem", color: "#94a3b8", lineHeight: 1.8 }}
              >
                Talktokam is an AI-powered chatbot platform that enables
                businesses to automate conversations, capture leads, and provide
                instant support — 24/7. With a visual flow builder, pre-built AI
                agents, live chat, and real-time analytics, Talktokam makes it
                easy for anyone to create intelligent conversational experiences
                without writing code. Trusted by thousands of businesses across
                40+ countries.
              </Typography>
            </Box>
          </motion.div>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: "#cbd5e1",
                mb: 1,
              }}
            >
              Press Contact
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", color: "#38bdf8" }}>
              press@talktokam.com
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PressKit;
